import $ from 'jquery';
import Swal from 'sweetalert2';
import { openModal, closeModal } from './modal.js';

export const modalSaveReport = customValidation => {
  let saved = false;
  const $links = document.querySelectorAll('a:not(.js-new-guest):not(.js-delete)');
  const $exitButton = document.querySelector('#modal-save .js-modal-exit');
  const $saveExitButton = document.querySelector('#modal-save .js-modal-save-exit');
  const $buttonSave = document.querySelector('.js-save-report');
  const $form = document.querySelector('.js-form-report');

  // Adiciona a função de abertura do modal a todos os links na página
  $links.forEach($el => {
    $el.addEventListener('click', e => {
      const url = e.currentTarget.href;

      // Se os dados ainda não foram salvos e o link de saída tem URL, prossegue
      if (!saved) {
        e.preventDefault();

        // abre o modal
        openModal('#modal-save');

        if (url.length) {
          // adiciona a URL de saída ao botão sair sem salvar
          $exitButton.setAttribute('data-href', e.currentTarget.href);
          // adiciona a URL de saída ao botão sair e salvar
          $saveExitButton.setAttribute('data-href', e.currentTarget.href);
        }
      }
    });
  });

  // Função para decidir se deve validar antes de salvar
  const shouldSave = action => {
    if (!customValidation || customValidation()) {
      saveForm($form, action);
    }
  };

  // Evento de click do botão salvar fora do modal
  $buttonSave.addEventListener('click', e => {
    e.preventDefault();
    shouldSave('keep');
  });

  // Evento de click do botão de sair e salvar dentro do modal
  $saveExitButton.addEventListener('click', e => {
    e.preventDefault();
    shouldSave('exit');
  });

  // Evento de click do botão de sair sem salvar dentro do modal
  $exitButton.addEventListener('click', e => {
    e.preventDefault();

    // pega o atributo de href para sair da página
    const href = e.currentTarget.getAttribute('data-href');

    // faz o redirect
    window.location = href;
  });

  // Salva os dados e executa a ação enviada:
  // keep: salva e fica na página
  // exit: salva e sai da página
  const saveForm = (form, action) => {
    const url = form.getAttribute('action');

    $.ajax({
      type: 'POST',
      url: url,
      data: $(form).serialize(),
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          saved = true;

          if (action == 'keep') {
            closeModal('#modal-save');
            Swal.fire(data.title, data.message, data.type);
          } else if (action == 'exit') {
            const href = $saveExitButton.getAttribute('data-href');
            window.location = href;
          }
        }
      },
    });
  };
};
